import axios from "axios";
import { BASEURL } from "baseUrl";
import { toast } from "react-toastify";

export const ADD_IMAGES = 'ADD_IMAGES';
export const GET_IMAGES = 'GET_IMAGES';
export const DELETE_IMAGES = 'DELETE_IMAGES';

const addImageAction = (payload) => ({ type: ADD_IMAGES, payload: payload });
const getImageAction = (payload) => ({ type: GET_IMAGES, payload: payload });
const deleteImageAction = (payload) => ({ type: DELETE_IMAGES, payload: payload });

export const addImages = (payload, userId) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.post(`${BASEURL}/PatientImage/add`, payload, {
                headers: {
                    authorization: `Bearer ${token}`
                }
            }).then(((res) => {
                dispatch(addImageAction(res));
                dispatch(getImages(userId))
                toast.success('Add Images Successfully')
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(addImageAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const getImages = (userId) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.get(`${BASEURL}/PatientImage/images?userId=${userId}`, {
                headers: {
                    authorization: `Bearer ${token}`
                }
            }).then(((res) => {
                dispatch(getImageAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getImageAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const deleteImages = (userId, selectedPatientId, payload) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.post(`${BASEURL}/PatientImage/deleteImages/${userId}`, payload, {
                headers: {
                    authorization: `Bearer ${token}`
                }
            }).then(((res) => {
                dispatch(deleteImageAction(res));
                dispatch(getImages(selectedPatientId))
            })).catch((error) => {
                console.log("Error", error);
                dispatch(deleteImageAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}